var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMgtA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 19.1H17V62.8H84.2V19.1Z",
    fill: "url(#paint0_linear_2_412)",
    stroke: "white",
    strokeWidth: 0.7549
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1999 20.1H17.5999V62.4H83.1999V20.1Z",
    stroke: "#9E9E9E",
    strokeWidth: 0.2602
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1999 20.1H17.5999V62.4H83.1999V20.1Z",
    stroke: "#545454",
    strokeWidth: 0.2602
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 18.5L16.2999 63.3L21.9 63.4L22 65.4H49.7999L49.7 63.4L66.5 63.3V65.4H78.8L78.6999 63.4H84.8V18.5H16.2ZM17.5 20.1H83.3V62.3H17.5V20.1Z",
    fill: "#2A4E69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3 80C98.3 80 98 80.9 97.1 81.5H2.89995C2.89995 81.5 1.69995 81 1.69995 80.2C1.69995 79.3 4.19995 79.1 4.19995 79.1H97.5C97.5 79.1 98.3 79.3 98.3 80Z",
    fill: "#2A4E69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4 66L97.4 77.3C97.4 77.3 98.3 78.1 98.3 80L1.69995 80.2C1.69995 80.2 1.99995 77.8 2.99995 77.1C4.09995 76.4 15.7 66.1 15.7 66.1L84.4 66Z",
    fill: "#2A4E69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 71.8L17.7998 67.4L82.4998 67.3L86.7998 71.8H13.2998Z",
    fill: "#E8F0F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3999 67.5L86.3999 71.7H13.6999L17.7999 67.6L82.3999 67.5ZM82.5999 67.2L17.7999 67.3L12.8999 72H87.1999L82.5999 67.2Z",
    fill: "#294F69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9 73L62.0999 75.3H42.7L43.4 73H60.9Z",
    fill: "#E8F0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6999 65.6C49.6999 66.2 49.3999 66.6 50.3999 66.6H65.4999C66.4999 66.6 66.3999 66.1 66.3999 65.4C66.3999 64.8 66.4999 64.2 65.4999 64.2H50.3999C49.3999 64.3 49.6999 65 49.6999 65.6Z",
    fill: "#2A4E69"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6998 65.6C15.6998 66.2 15.5998 66.6 15.9998 66.6H21.5998C21.9998 66.6 21.9998 66.1 21.9998 65.4C21.9998 64.8 21.9998 64.2 21.5998 64.2H15.9998C15.5998 64.3 15.6998 65 15.6998 65.6Z",
    fill: "#2A4E69"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7999 65.6C78.7999 66.2 78.6999 66.6 79.0999 66.6H84.2999C84.5999 66.6 84.5999 66.1 84.5999 65.4C84.5999 64.8 84.5999 64.2 84.2999 64.2H78.9999C78.6999 64.3 78.7999 65 78.7999 65.6Z",
    fill: "#2A4E69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1999 68H83.0999L83.1999 67.8H17.0999L17.1999 68ZM17.1999 68H83.0999V67.8H17.0999L17.1999 68Z",
    fill: "#294F69"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2999 68.9H84L84.0999 68.7H16.2999V68.9ZM16.2999 68.9H84L84.0999 68.7H16.2L16.2999 68.9Z",
    fill: "#294F69"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2999 70H84.9999L85.0999 69.8H15.1999L15.2999 70ZM15.2999 70H84.9999L85.0999 69.8H15.0999L15.2999 70Z",
    fill: "#294F69"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2999 71H85.9999L86.0999 70.8H14.0999L14.2999 71ZM14.2999 71H85.9999L86.0999 70.8H14.0999L14.2999 71Z",
    fill: "#2A4E69"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8987 48V36.264H28.7967L30.6867 41.484C30.8067 41.82 30.9207 42.174 31.0287 42.546C31.1367 42.918 31.2507 43.284 31.3707 43.644H31.4427C31.5627 43.284 31.6707 42.918 31.7667 42.546C31.8747 42.174 31.9887 41.82 32.1087 41.484L33.9627 36.264H36.8427V48H34.4307V43.698C34.4307 43.314 34.4487 42.888 34.4847 42.42C34.5327 41.94 34.5807 41.46 34.6287 40.98C34.6887 40.5 34.7367 40.074 34.7727 39.702H34.7007L33.7467 42.492L32.0727 46.974H30.6147L28.9407 42.492L28.0047 39.702H27.9327C27.9807 40.074 28.0287 40.5 28.0767 40.98C28.1247 41.46 28.1667 41.94 28.2027 42.42C28.2507 42.888 28.2747 43.314 28.2747 43.698V48H25.8987ZM44.7936 48.216C43.7256 48.216 42.7536 47.988 41.8776 47.532C41.0136 47.076 40.3236 46.404 39.8076 45.516C39.3036 44.616 39.0516 43.512 39.0516 42.204C39.0516 40.908 39.3096 39.804 39.8256 38.892C40.3536 37.968 41.0496 37.266 41.9136 36.786C42.7776 36.294 43.7316 36.048 44.7756 36.048C45.6276 36.048 46.3596 36.204 46.9716 36.516C47.5836 36.828 48.0816 37.182 48.4656 37.578L47.0796 39.27C46.7796 39.006 46.4616 38.784 46.1256 38.604C45.7896 38.424 45.3696 38.334 44.8656 38.334C43.9536 38.334 43.2096 38.67 42.6336 39.342C42.0576 40.014 41.7696 40.938 41.7696 42.114C41.7696 43.314 42.0456 44.25 42.5976 44.922C43.1496 45.594 43.9716 45.93 45.0636 45.93C45.3036 45.93 45.5376 45.9 45.7656 45.84C45.9936 45.78 46.1796 45.69 46.3236 45.57V43.554H44.3796V41.394H48.6636V46.794C48.2556 47.19 47.7096 47.526 47.0256 47.802C46.3536 48.078 45.6096 48.216 44.7936 48.216ZM53.0226 48V38.496H49.8006V36.264H58.9086V38.496H55.6866V48H53.0226ZM58.9664 44.382V42.51H63.3944V44.382H58.9664ZM68.3089 42.06L68.0209 43.14H70.5229L70.2529 42.06C70.0969 41.472 69.9349 40.848 69.7669 40.188C69.6109 39.528 69.4549 38.892 69.2989 38.28H69.2269C69.0829 38.904 68.9329 39.546 68.7769 40.206C68.6329 40.854 68.4769 41.472 68.3089 42.06ZM64.0609 48L67.7329 36.264H70.9189L74.5909 48H71.7829L71.0629 45.21H67.4809L66.7609 48H64.0609Z",
    fill: "#2A4E69"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_412",
    x1: 16.9732,
    y1: 40.9145,
    x2: 84.1644,
    y2: 40.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMgtA);
export default __webpack_public_path__ + "static/media/mgt-a.1dec527f800b0adfaaba82b1362bb640.svg";
export { ForwardRef as ReactComponent };